@if (enableSavedFilters() && savedFilters().length > 0) {
  <div class="saved-filters-row">
    <div class="saved-filters-container">
      @for (sf of savedFilters(); track sf.id ?? sf.name) {
        <button
          type="button"
          class="saved-filter-chip"
          [class.saved-filter-chip--active]="isSavedFilterActive(sf)"
          [style.background]="sf.color"
          (click)="onSavedFilterClick(sf)">
          <span
            class="saved-filter-chip__body"
            [pTooltip]="isSavedFilterActive(sf) ? 'Desativar filtro' : 'Aplicar filtro salvo'">
            <i [class]="sf.icon"></i>
            <span class="saved-filter-chip__name">{{ sf.name }}</span>
          </span>
          <i
            class="pi pi-times saved-filter-chip__remove"
            (click)="onDeleteFilter($event, sf)"
            pTooltip="Excluir filtro"></i>
        </button>
      }
    </div>
  </div>
}
